<template>
  <div class="mostly-search text-clamp1" @mouseover="_clearMostlyInterval" @mouseout="_setMostlyInterval">
    <span class="title">大家都在搜：</span>
    <div
      class="list"
    >
      <router-link
        class="search-word simple-click-hover a-text-none"
        :to="OpenService.getSearchLibUrl(item)"
        :target="OpenService.getRouterTarget()"
        v-for="item of wrodList"
        :key="item"
        :title="item"
      >
        {{ item }}
      </router-link>
    </div>
    <div class="refresh simple-click-hover" @click="this.getSearchKeyword">
      <i class="el-icon-refresh"></i>
      <span>换一换</span>
    </div>
  </div>
</template>

<script>
import { TodaySearchService, OpenService } from "@/service";
import {WinForm} from '@/libs';
import refreshIcon from "@/assets/images/search/refresh.png";

export default {
  data() {
    return {
      loading: true,
      dataSource: [],

      refreshIcon,
      OpenService,
    };
  },
  computed: {
    // 前端随机
    wrodList() {
      let result = [];
      let arr = [...this.dataSource];
      let count = 8; // 显示的数量
      for (let i = 0; i < count; i++) {
        let index = Math.floor(Math.random() * arr.length);
        if (result.indexOf(arr[index]) === -1) {
          result[i] = arr[index];
          arr.splice(index, 1);
        }
      }
      return result;
    },
  },
  methods: {
    // 搜索关键词(联想词)
    async getSearchKeyword() {
      this.loading = true;
      const res = await TodaySearchService.getSearchKeyword();
      if (res.code === 0) {
        this.dataSource = res.data;
      }
      this.loading = false;
    },
    _setMostlyInterval() {
      this._clearMostlyInterval();
      this.mostlyInterval = setInterval(() => {
        if (document.visibilityState === 'hidden') return;
        if (WinForm.md.getWindowState() === 1) return;
        if (WinForm.md.getTabIndex() !== 0) return;
        !this.loading && this.getSearchKeyword();
      }, 6000)
    },
    _clearMostlyInterval() {
      this.mostlyInterval && clearInterval(this.mostlyInterval);
    }
  },
  mounted() {
    this.getSearchKeyword();
    this._setMostlyInterval();
  },
  beforeDestroy() {
    this._clearMostlyInterval();
  }
};
</script>
<style lang="less" scoped>
.mostly-search {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: @text-color-help-dark;
  margin-top: 16px;
  margin-bottom: 15px;

  .title {
    color: #2F3748;
    margin-right: 16px;
  }

  .list{
    max-width: 1070px;
    overflow: hidden;
  }

  .search-word {
    margin-right: 16px;
    align-self: center;
    font-size: 13px;
  }

  .refresh {
    display: flex;
    align-items: center;
    color: @a-color-active;
    img {
      width: 18px;
      height: 18px;
    }
    span {
      margin-left: 2px;
      color: @a-color-active;
    }
  }
}
</style>